import { axiosIns } from "../utils";

/**
 * Formation list for the back-office.
 *
 * `/formations/all/` rather than `/formations/`: the latter is the mobile
 * route, which hides finished formations and drafts. The back-office must see
 * the whole history.
 */
export const fetchFormations = async (params = {}) => {
  const response = await axiosIns.get("/formations/all/", { params });
  return response && response.data ? response.data : response;
};

export const fetchFormationById = async (id) => {
  const response = await axiosIns.get(`/formations/${id}/`);
  return response && response.data ? response.data : response;
};

export const createFormationApi = async (payload) => {
  const response = await axiosIns.post("/formations/", payload);
  return response && response.data ? response.data : response;
};

export const updateFormationApi = async (id, payload) => {
  const response = await axiosIns.patch(`/formations/${id}/`, payload);
  return response && response.data ? response.data : response;
};

export const validateFormationApi = async (id) => {
  const response = await axiosIns.patch(`/formations/${id}/publish/`);
  return response && response.data ? response.data : response;
};

export const deleteFormationApi = async (id) => {
  const response = await axiosIns.delete(`/formations/${id}/`);
  return response && response.data ? response.data : response;
};
